import { DashboardContainer } from 'widgets/dashboardContainer';

export const Applications = () => {
	return (
		<DashboardContainer>
			<div>content</div>
		</DashboardContainer>
	);
};
